// extracted by mini-css-extract-plugin
export default {"hideTooltip":"K9-z","fadeIn":"L9-z","delay":"M9-z","recommendedSizeTooltip":"N9-z"};